import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './BanksPayouts.css';
import { useBanksPayouts } from '../../hooks/useBanksPayouts';
import PieChart from '../PieChart/PieChart';
import { Card, Carousel, Empty, Table } from 'antd';
import { format, NumberKind } from '../../helpers/numberUtils';
import { ProductType } from "motty-utils";
import { productToString } from "../../helpers/productToString";
const BanksPayouts = () => {
    const bankPayouts = useBanksPayouts();
    const slidingSpeed = parseFloat((new URL(window.location.href)).searchParams.get('speed') || '20');
    const banksPayoutsColumns = [
        {
            title: 'Bank',
            dataIndex: 'bank',
            key: 'bank'
        },
        {
            title: 'Paid amount',
            dataIndex: 'paidAmount',
            key: 'paidAmount',
            render: paidAmount => format(paidAmount, { type: NumberKind.Currency, abbreviate: true })
        },
        {
            title: 'Total payouts',
            dataIndex: 'amountOfPayouts',
            key: 'amountOfPayouts'
        },
        {
            title: 'Avg. Nominal',
            dataIndex: 'avgNominal',
            key: 'avgNominal',
            render: avgNominal => format(avgNominal, { type: NumberKind.Percent, precision: 0 })
        }
    ];
    const formatBankPayoutLabel = (bankPayout) => {
        return `${bankPayout.bank} ${format(bankPayout.paidAmount, { type: NumberKind.Currency, abbreviate: true })}`;
    };
    const renderEmptyBanksPayouts = () => (_jsx(Empty, { description: "No payouts yet!" }));
    const renderBanksPayouts = (payouts) => (_jsxs(_Fragment, { children: [_jsx(Table, { pagination: false, columns: banksPayoutsColumns, dataSource: payouts, rowKey: payout => payout.bank }), _jsx(PieChart, { data: payouts, valueKey: "paidAmount", labelKey: "bank", formatLabel: formatBankPayoutLabel })] }));
    const renderProductCard = (product) => {
        const content = !bankPayouts[product].length ? renderEmptyBanksPayouts() : renderBanksPayouts(bankPayouts[product]);
        return (_jsx(Card, { title: productToString(product), className: "product-card", size: "small", children: content }));
    };
    return (_jsxs(Carousel, { adaptiveHeight: true, className: "banks-payouts", autoplay: true, dotPlacement: "start", autoplaySpeed: slidingSpeed * 350, children: [renderProductCard(ProductType.ConsumerLoan), renderProductCard(ProductType.CreditCard), renderProductCard(ProductType.Mortgage)] }));
};
export default BanksPayouts;
